// 표 선택 내역을 CSV로 내보내는 순수 함수들.
//
// BITO_0425 p34(4/11, "선택 checkbox 추가" + 다운로드)와 BITO_0425/0515 p43/p54(같은 데크 뒤쪽,
// "Excel Download는 CSV 기능으로 대체")를 합쳐 읽은 결과 — "체크박스로 선택한 행을 CSV로
// 내보낸다"가 최종 요구다(요구사항 추출 문서 5번 "슬라이드끼리 충돌" 참고). 엑셀에서 한글이 깨지지
// 않도록 UTF-8 BOM을 붙인다.
//
// buildCsv/toCsvRow는 DOM에 의존하지 않는 순수 함수라 유닛테스트가 쉽다. 실제 다운로드(Blob/anchor)는
// downloadCsv가 맡는다.

const CSV_BOM = '﻿';

/** 값 하나를 CSV 필드로 이스케이프한다(쉼표·줄바꿈·따옴표 포함 시 큰따옴표로 감싼다). */
export const toCsvField = (value) => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

/**
 * columns: [{ field, headerName }] — DataGrid columns 배열을 그대로 넘겨도 된다(필요 없는 칸은
 *   호출하는 쪽에서 미리 걸러서 넘긴다. 예: hide/숨김 칸, 'action' 같은 렌더 전용 칸).
 * rows: 평범한 객체 배열(각 객체의 column.field 값을 읽는다).
 * 반환: BOM이 붙은 CSV 문자열(\r\n 줄바꿈, 엑셀 호환).
 */
export const buildCsv = (columns, rows) => {
  const cols = columns || [];
  const data = rows || [];
  const header = cols.map((c) => toCsvField(c.headerName || c.field)).join(',');
  const lines = data.map((row) =>
    cols.map((c) => toCsvField(row?.[c.field])).join(','),
  );
  return CSV_BOM + [header, ...lines].join('\r\n');
};

/** 선택된 행이 있으면 선택 행만, 없으면(길이 0) 넘어온 전체(필터된) 행을 내보낼 대상으로 고른다. */
export const pickRowsToExport = (rows, selectedIds) => {
  const data = rows || [];
  if (!selectedIds || selectedIds.length === 0) return data;
  const idSet = new Set(selectedIds);
  return data.filter((row) => idSet.has(row.id));
};

/** 브라우저에서 CSV 문자열을 파일로 내려받는다. */
export const downloadCsv = (csvString, fileName) => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
